// Aucun secret ne doit transiter par ce fichier.
// Les anciens credentials, clés API et tokens ont été supprimés :
//   - export const googleApiKey = "..."           // SUPPRIMÉ (était dans le bundle)
//   - export const googleClientId = "..."         // SUPPRIMÉ (sera réinjecté via define si besoin)
//   - export const credentials = { username, password }  // SUPPRIMÉ
//
// L'authentification au backend ENSAD est désormais gérée intégralement
// côté Cloudflare Worker : le Worker injecte l'Authorization Basic vers
// ensad.oasispro.fr après vérification du header X-App-Key.
// Le frontend n'envoie plus aucun couple user/password.

export const appliname = 'OASIS Planning Viewer';

export const filter_header1 = ['Jour', 'Jour du mois'];
export const filter_header2 = ['Annee'];
export const filter_filterValue = ['Annee', 'Secteur', 'Salle', 'Professeur', 'Type'];
export const filter_colors: string[] = ['Secteur', 'Annee','Professeur'];

export const show_sources = false;
export const burger_menu = true;

export const default_start_time=9
export const default_end_time=20

// Valeur des masques
export const show_masks = false;
export const default_event_mask = '<g>{titre}</g> - {salle}<br>{Prof}<br>{plage}';
export const default_event_infobulle =
  'Titre: {titre}\n\nCode:{code}\nSecteur: {secteur}\nSemestre: {semestre}\nProfesseurs: {professeurs}\nType de cours: {type}\n\n{Prof}';

// Domaine canonique utilisé uniquement pour les liens externes (context menu)
// et la redirection OAuth Google. Non sensible.
export const domain_oasis = 'https://ensad.oasispro.fr';
export const context_menu_enabled = [
  'Séance',
  'Cours',
  'Salle',
  'Filtrer sur ce secteur',
  'Filtrer sur la salle',
];
export const toolbar_visibility_for_share = 'true';

// Valeurs injectées au build via angular.json -> architect.build.configurations.<env>.define
declare const proxy: string;

// Ré-export pour les modules qui n'importent que depuis env.ts
export const apiBase = proxy;
